export const headerItemsWithParams = [
  {
    path: '/aprovacoes',
    title: 'Aprovações',
    icon: 'file',
  },
  {
    path: '/clinica/white-label',
    title: 'Configurações WhiteLabel',
    icon: 'clipboard',
  },
  {
    path: '/faturamento/regras-cadastradas',
    title: 'Regras cadastradas',
    icon: 'clipboard',
  },
  {
    path: '/usuario/pacientes/atendimentos',
    title: 'Atendimentos',
    icon: 'user',
  },
  {
    path: '/usuario/pacientes/psicologos-vinculados',
    title: 'Psicólogos vinculados',
    icon: 'clipboard-saved',
  },
  {
    path: '/modularizacao/editar-template',
    title: 'Configuração de prontuário',
    icon: 'clipboard',
  },
  {
    path: '/modularizacao/visualizar-template',
    title: 'Configuração de prontuário',
    icon: 'clipboard',
  },
  {
    path: '/usuario/pacientes/editar',
    title: 'Visualizar e editar paciente',
    icon: 'user',
  },
  {
    path: '/templates-prontuario',
    title: 'Config de Prontuário',
    icon: 'medical-certificate',
  },
]

export const headerItems = {
  '/faturamento/conexa-tiss': {
    title: 'Conexa TISS',
    icon: 'clipboard',
  },
  '/faturamento/contratos-faturamento': {
    title: 'Contratos de faturamento',
    icon: 'clipboard',
  },
  '/faturamento/boas-vindas': {
    title: 'Cadastrar contratos',
    icon: 'clipboard',
  },
  '/faturamento/extrato-faturamento/gerar-extrato': {
    title: 'Extrato de Faturamento',
    icon: 'clipboard',
  },
  '/faturamento/extrato-faturamento': {
    title: 'Extrato de Faturamento',
    icon: 'clipboard',
  },
  '/faturamento/cadastro-contrato': {
    title: 'Cadastrar contratos',
    icon: 'clipboard',
  },
  '/faturamento/extrato-faturamento/gerar-extrato/visualizar': {
    title: 'Extrato de Faturamento',
    icon: 'clipboard',
  },
  '/faturamento/visualizar-contratos': {
    title: 'Regras cadastradas',
    icon: 'clipboard',
  },
  '/faturamento/selecionar-categorias': {
    title: 'Cadastrar regras',
    icon: 'clipboard',
  },
  '/faturamento/anexar-arquivo': {
    title: 'Cadastrar contratos',
    icon: 'clipboard',
  },
  '/faturamento/vigencia-do-contrato': {
    title: 'Cadastrar contratos',
    icon: 'clipboard',
  },
  '/faturamento/cadastrar-regras/informacoes-gerais': {
    title: 'Cadastrar regras',
    icon: 'clipboard',
  },
  '/faturamento/cadastrar-regras/regras-atendimento': {
    title: 'Cadastrar regras',
    icon: 'clipboard',
  },
  '/faturamento/cadastrar-regras/regras-vidas': {
    title: 'Cadastrar regras',
    icon: 'clipboard',
  },
  '/faturamento/cadastrar-regras/regras-licencas': {
    title: 'Cadastrar regras',
    icon: 'clipboard',
  },
  '/faturamento/cadastrar-regras/regras-resumo': {
    title: 'Cadastrar regras',
    icon: 'clipboard',
  },
  '/faturamento/faturamento-por-vidas': {
    title: 'Faturamento por vidas',
    icon: 'clipboard',
  },
  '/faturamento/gerar-extrato': {
    title: 'Extrato de Faturamento',
    icon: 'clipboard',
  },

  '/conta/contas': {
    title: 'Conta',
    icon: 'clipboard',
  },
  '/conta/criar-conta': {
    title: 'Cadastrar uma conta',
    icon: 'clipboard',
  },

  '/modularizacao/home': {
    title: 'Configuração de prontuário',
    icon: 'clipboard',
  },
  '/modularizacao/criar-template': {
    title: 'Configuração de prontuário',
    icon: 'clipboard',
  },

  '/atendimento/agendar/consulta': {
    title: 'Agendamento de consultas',
    icon: 'clipboard',
  },
  '/atendimento/agendar/consulta/profissionais': {
    title: 'Agendamento de consultas',
    icon: 'clipboard',
  },
  '/atendimento/atendimento-log': {
    title: 'Log de atendimentos',
    icon: 'clipboard',
  },
  '/atendimento/prontuario': {
    title: 'Prontuário',
    icon: 'clipboard',
  },
  '/atendimento/logs-comunicacao': {
    title: 'Logs de comunicação',
    icon: 'clipboard',
  },
  '/atendimento/fila-atendimento': {
    title: 'Fila de atendimento',
    icon: 'clipboard',
  },
  '/atendimento/historico-atendimentos': {
    title: 'Histórico de agendamentos',
    icon: 'receipt',
  },
  '/atendimento/liberacao-plano-saude': {
    title: 'Liberação de plano de saúde',
    icon: 'receipt',
  },
  '/atendimento/liberacao-plano-saude/detalhes': {
    title: 'Liberação de plano de saúde',
    icon: 'receipt',
  },
  '/clinica/especialidades-customizadas': {
    title: 'Especialidades customizadas',
    icon: 'receipt',
  },
  '/atendimento/lista-de-encaminhamentos': {
    title: 'Lista de encaminhamentos',
    icon: 'clipboard',
  },
  '/clinica/especialidades-customizadas/historico-alteracoes': {
    title: 'Histórico de alterações',
    icon: 'receipt',
  },
  '/clinica/customizacao-limite-atendimento': {
    title: 'Limite de atendimento',
    icon: 'hospital',
  },

  '/dashboard/atendimento': {
    title: 'Dashboard',
    icon: 'dashboard',
  },
  '/dashboard/atendimentos': {
    title: 'Dashboard',
    icon: 'dashboard',
  },
  '/dashboard/solicitacoes': {
    title: 'Dashboard',
    icon: 'dashboard',
  },
  '/usuario/admin-clinica': {
    title: 'Admin Clínica',
    icon: 'user',
  },
  '/usuario/detalhes-atendimento/detalhes-consulta': {
    title: 'Atendimentos',
    icon: 'user',
  },
  '/admin-clinica/usuario': {
    title: 'Adicionar usuário',
    icon: 'user',
  },

  '/cupom/gerar-cupons': {
    title: 'Cupom',
    icon: 'receipt-bullet',
  },

  '/audit-tracker': {
    title: 'Audit tracker',
    icon: 'clipboard',
  },

  '/usuario/pacientes': {
    title: 'Paciente',
    icon: 'user',
  },
  '/usuario/admin-conexa': {
    title: 'Admin Conexa',
    icon: 'user',
  },
  '/usuario/admin-conexa/usuario': {
    title: 'Admin Conexa',
    icon: 'user',
  },
  '/usuario/pacientes/cadastrar': {
    title: 'Adicionar Paciente',
    icon: 'user',
  },
  '/usuario/profissionais': {
    title: 'Nova busca',
    icon: 'doctor-talk',
  },
  '/paciente/cpfs-bloqueados': {
    title: 'CPFs bloqueados',
    icon: 'user',
  },
  '/corpo-clinico': {
    title: 'Corpo Clínico',
    icon: 'group',
  },
}
